/**
 * Firebase configuration
 */
export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
} as const

/**
 * Environment configuration for Firebase emulators
 */
export const emulatorConfig = {
    enabled: import.meta.env.VITE_USE_EMULATOR === 'true',
    host: import.meta.env.VITE_EMULATOR_HOST || '127.0.0.1',
    ports: {
        auth: Number(import.meta.env.VITE_AUTH_EMULATOR_PORT) || 9099,
        firestore: Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT) || 8081,
        functions: Number(import.meta.env.VITE_FUNCTIONS_EMULATOR_PORT) || 5001,
    },
} as const
